import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeaturedArticles } from './components/FeaturedArticles';
import { ValueProps } from './components/ValueProps';
import { SocialProof } from './components/SocialProof';
import { ChatBotPreview } from './components/ChatBotPreview';
import { Footer } from './components/Footer';
import { ChatBot } from './components/ChatBot';
export function App() {
  const triggerChat = () => {
    const chatButton = document.querySelector('button[aria-label="Open chat"]') as HTMLButtonElement;
    if (chatButton) chatButton.click();
  };
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-slate selection:bg-brand-gold/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection onOpenChat={triggerChat} data-id="element-3" />
        <ValueProps data-id="element-4" />
        <ChatBotPreview onOpenChat={triggerChat} data-id="element-5" />
        <FeaturedArticles data-id="element-6" />
        <SocialProof data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
      <ChatBot data-id="element-9" />
    </div>;
}